'use client';

import React, { useState, useEffect } from 'react';
import { RiCloseLine } from 'react-icons/ri';
import safeCreatePortal from './safeCreatePortal';

const VideoPopup = ({ videoUrl, isOpen, onClose }) => {
    const [container, setContainer] = useState(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setContainer(document.body);
        }
    }, []);

    if (!isOpen) return null;

    return safeCreatePortal(
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-80" onClick={onClose}>
            <div className="relative w-full max-w-4xl p-2 mx-4 bg-white rounded-lg" onClick={(e) => e.stopPropagation()}>
                <button className="absolute right-0 p-2 text-white transition-colors rounded-full -top-10 bg-main-color hover:bg-opacity-90" onClick={onClose}>
                    <RiCloseLine className="size-6" />
                </button>
                <div className="relative aspect-video">
                    <iframe
                        width="100%"
                        height="100%"
                        src={videoUrl}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded"
                    ></iframe>
                </div>
            </div>
        </div>,
        container
    );
};

const VideoPopupHandler = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    // Define the function to open the video popup
    const openVideoPopup = (url) => {
        setVideoUrl(url);
        setIsPopupOpen(true);
        if (typeof window !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        if (typeof window !== 'undefined') {
            document.body.style.overflow = '';
        }
    };

    // Export the openVideoPopup function to window so it can be accessed globally
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.openVideoPopup = openVideoPopup;
        }

        return () => {
            if (typeof window !== 'undefined') {
                delete window.openVideoPopup;
            }
        };
    }, []);

    return <VideoPopup videoUrl={videoUrl} isOpen={isPopupOpen} onClose={closePopup} />;
};

export default VideoPopupHandler;
